<script>
    import { graphDataStore } from './stores';
    import { onMount } from 'svelte';
    import Twitter from './Twitter.svelte';
    import WidgetSentiment from './WidgetSentiment.svelte';
    import { SENTIMENT_BASE_URL } from './constants.js';


    let topTweets;
    onMount(() => {
        const unsubscribe = graphDataStore.subscribe((graphData) => {
            if (!graphData) return;
            topTweets = graphData.top_tweets.map(tweet => "https://twitter.com/x/status/"+tweet.id);
        });

        return () => {
            // Unsubscribe from the store on component unmount
            unsubscribe();
        };
      
    });

    let showTopTweets = false;
    let tweetUrl = '-';
    let sentiment;
    let sentimentReason;
    let showTwitter = false;
    function toggleTopTweets() {
        showTopTweets = !showTopTweets;
        showTwitter = false;
    }

    async function handleClick(tweet) {
        showTwitter = false;
        tweetUrl = tweet;
        sentiment = null;
        sentimentReason = null;
        
        // Use setTimeout to delay the execution
        setTimeout(() => {
            showTwitter = true;
            getSentiment(tweet);
        }, 0);
    }
    
    async function getSentiment(tweet) {
        // const response = await fetch(`https://sentiment.graph.gv.my/?tweeturl=${tweet}`);
        const response = await fetch(`${SENTIMENT_BASE_URL}?tweeturl=${tweet}`);
        if (response.ok) {
            const data = await response.json();
            sentiment = data.content.split('|')[0];
            sentimentReason = data.content.split('|')[1];
        } else {
            sentiment = 'Error';
            sentimentReason = 'Error';
        }
    }
    
</script>
<div class="bg-blueish-black border-4 rounded-lg left-10 space-x-2 p-3">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="flex items-center justify-between cursor-pointer" on:click={toggleTopTweets}>
        <h3 class="text-white pl-2">Top Tweets</h3>
        <span class="text-white">
            {#if showTopTweets}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
                </svg>
            {:else}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5" />
                </svg>
            {/if}
        </span>
    </div>
</div>
{#if showTopTweets}
    {#if topTweets }
        <div class="absolute w-2/6 bg-blueish-black opacity-90 border-4 rounded-lg space-x-2 p-3" style="left: 20%">
            {#each topTweets as tweet}
                <a href={tweet} target="_blank" on:click|preventDefault={handleClick(tweet)}>
                    <div class="text-white font-bold overflow-hidden overflow-ellipsis whitespace-nowrap pl-2 mt-2">{tweet}</div>
                </a>
            {/each}
        </div>
    {/if}
{/if}

<div class="p-1 absolute top-25 right-20">
    {#if showTwitter && tweetUrl != '-' } 
        <Twitter { tweetUrl } />
    {/if}
</div>
{#if showTwitter && tweetUrl != '-' && sentiment} 
    <WidgetSentiment { sentiment } { sentimentReason } />
{/if}